import { useState, useEffect } from 'react'
import { getPrefs } from '../api'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

export const useGetCWQSPrefsOnMount = () => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const result = await dispatch(getPrefs())

        if (mounted) {
          if (getPrefs.fulfilled.match(result)) {
            setStatus('success')
          } else {
            setStatus('fail')
          }
        }
      } catch {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return status
}
